import { render, staticRenderFns } from "./BaseSpace.vue?vue&type=template&id=05661d96&scoped=true&"
import script from "./BaseSpace.vue?vue&type=script&lang=js&"
export * from "./BaseSpace.vue?vue&type=script&lang=js&"
import style0 from "./BaseSpace.vue?vue&type=style&index=0&id=05661d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05661d96",
  null
  
)

export default component.exports